module.exports = __webpack_public_path__ + "static/media/ai-synonyms-guide.464143fb.png";